import Breadcrumbs from '../../../components/molecules/breadcrumbs/Breadcrumbs';
import tastify from '@frontastic/catwalk/src/js/helper/tastify';
import React from 'react';

const BreadcrumbsTastic = (props) => {
  const { data, context } = props;
  if (!data) return null;

  const locale = context?.locale === 'en_AU@AUD' ? 'AU' : 'NZ';
  if (!data[`show${locale}`]) return null;

  return (
    <Breadcrumbs
      crumbs={data.breadcrumbsLinks}
      cropThreshold={100}
      marginBottom={data.marginBottom}
      absoluteMode={data.absoluteMode}
    />
  );
};

export default tastify({
  translate: true,
  connect: {
    context: true,
  }
})(BreadcrumbsTastic);
